import React,{ Component } from "react";
import { Modal,ModalHeader,Button,ModalBody, ModalFooter } from "reactstrap";
import { updateUserAttribute} from "../../actions/actionUser";
import { connect } from "react-redux";

class GenericModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            checked: false
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleClose() {
        this.setState({ show: false });
        this.props.updateUserAttribute({"show_tips": !this.state.checked});
    }

    toggle(){
        this.setState({ modal: !this.state.modal }); 
    }

    handleShow() {
        this.setState({ show: true });
    }

    componentDidMount(){
        this.setState({ show: true });
    }

    handleChange(){
        this.setState({
            checked: !this.state.checked
        });
    }

    render() {
        return (
            <div>
                <Modal zIndex={999999} isOpen={this.state.show} toggle={this.handleClose} >
                    <ModalHeader toggle={this.handleClose}>
                        Tips <i className="fa fa-info" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                        <p> Welcome to Kasm! </p>
                        <p> The Control Panel can be found on the left
                            side of the desktop and can be used for the Clipboard, Downloads,
                            Logout and Destroy features. Look for the following icon: <br />
                            <span style={{'paddingLeft':'10em', 'paddingTop':'1em', 'color':'grey'}}><i className="fa fa-ellipsis-v fa-3x" aria-hidden="true"></i></span>
                        </p>

                        <p>
                            <br />
                            <br />
                            <input
                                type="checkbox"
                                defaultChecked={this.state.checked}
                                ref="complete"
                                onChange={this.handleChange}
                            />
                            <label>&nbsp;Don't show tips on startup?</label>
                        </p>



                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleClose}>Got it</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        updateUserErrorMessage: state.user.updateUserErrorMessage,
        updateUserAttrLoading: state.user.updateUserAttrLoading,
        updateUserAttrError: state.user.updateUserAttrError
    };
}

function mapDispatchToProps(dispatch) {
    return ({
        updateUserAttribute: (data) => dispatch(updateUserAttribute(data))
    });
}

GenericModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(GenericModal);

export default GenericModal;


// WEBPACK FOOTER //
// ./src/components/GenericModal/GenericModal.js